import { Lightning as lng, Registry, Utils } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { CmsConstants } from '../../../Business/cms/CmsConstants';
import { GuideChannelPage } from './GuideChannelPage';

export const _constants = {
  channelInfoWidth: 322,
  channelInfoFadeLength: 80,
  channelInfoMargin: 2,
  channelInfoNumber: 90,
  channelHeight: 80, // should be the same as in EpgGuide.js
  channelInfoLogoHeight: 76,
  channelInfoLogoPos: 233,
  channelInfoLogoMaxWidth: 160,
  channelProgramsWidth: 1432,
  iconSize: 36,
  animationDurationSeconds: 0.5,
};

export class GuideChannel extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: _constants.channelHeight,
      ChannelInfo: {
        h: h => h,
        w: _constants.channelInfoWidth - _constants.channelInfoMargin,
        // rect: true,
        // color: Theme.Colors.Transparent,
        Background: {
          // TODO: change fade out
          w: w => w,
          h: h => h,
          Fade: {
            w: _constants.channelInfoFadeLength,
            h: h => h,
            rect: true,
            colorRight: Theme.Colors.Guide.background,
            colorLeft: Theme.Colors.Transparent,
          },
          Full: {
            x: _constants.channelInfoFadeLength,
            w: w => w - _constants.channelInfoFadeLength,
            h: h => h,
            rect: true,
            color: Theme.Colors.Guide.background,
          },
        },
        FavoriteIcon: {
          x: 0,
          mountY: 0.5,
          y: h => h / 2,
          w: _constants.iconSize,
          h: _constants.iconSize,
          src: Utils.asset('images/guide/ic_star.png'),
        },
        ChannelNumber: {
          mount: 0.5,
          x: _constants.channelInfoNumber,
          y: h => h / 2 + 5,
          // h: h => h,
          // w: 150,
          text: {
            ...Theme.Fonts.Guide.ChannelNumber,
            text: '',
          },
        },
        ChannelLogo: {
          mount: 0.5,
          x: _constants.channelInfoLogoPos,
          y: h => h / 2,
          w: _constants.channelInfoLogoMaxWidth,
          h: _constants.channelInfoLogoHeight,
          Contain: {
            mount: 0.5,
            x: w => w / 2,
            y: h => h / 2,
            texture: {
              type: lng.textures.ImageTexture,
              src: '',
              resizeMode: {
                type: 'contain',
                w: _constants.channelInfoLogoMaxWidth,
                h: _constants.channelInfoLogoHeight,
              },
            },
          },
        },
      },
      ClipBox: {
        clipping: true,
        x: _constants.channelInfoWidth - CmsConstants.Card.borderSize,
        y: -CmsConstants.Card.borderSize,
        w: w => w - _constants.channelInfoWidth + CmsConstants.Card.borderSize,
        h: h => h + CmsConstants.Card.borderSize * 2,
        ProgramContainer: {
          x: CmsConstants.Card.borderSize,
          y: CmsConstants.Card.borderSize,
          w: w => w - CmsConstants.Card.borderSize * 2,
          h: h => h - CmsConstants.Card.borderSize * 2,
          Page1: {
            x: -_constants.channelProgramsWidth - CmsConstants.Card.borderSize,
            h: h => h,
            w: w => w,
            type: GuideChannelPage,
          },
          Page2: {
            h: h => h,
            w: w => w,
            type: GuideChannelPage,
          },
          Page3: {
            x: _constants.channelProgramsWidth,
            h: h => h,
            w: w => w,
            type: GuideChannelPage,
          },
        },
      },
    };
  }

  _init() {
    this.focusIdx = 0;
    this.isActive = false;
    this.allowMove = true;
    this._backend = this.backend;
    if (this.filterState) {
      // pass filter to children
      this.updateFilterHighlights(this.filterState);
    }
    this.timeChanged = true;
    if (this.fromUntil) {
      this.currentStart = new Date(this.fromUntil.start);
      this.currentEnd = new Date(this.fromUntil.end);
    }
    // X value needs to be set here else the setSmooth command doesn't work when moving left or right
    // also this.tag('ProgramContainer').finalW cannot be used, it is zero at this moment
    this.tag('ProgramContainer').children[0].patch({
      backend: this._backend,
    });
    this.tag('ProgramContainer').children[1].patch({
      backend: this._backend,
    });
    this.tag('ProgramContainer').children[2].patch({
      backend: this._backend,
    });
    this.passDsToPages(this.datasource);
    this.prevLeftRightTime = Date.now();
    this.leftRightTimeout = 100;
    this.leftPageIndex = 0;
    this.currentPageIndex = 1;
    this.rightPageIndex = 2;
  }

  _getFocused() {
    return this.tag('ProgramContainer').children[this.currentPageIndex];
  }

  setNewData(ds, idx) {
    this._index = idx;
    this.datasource = ds;
    this.passDsToPages(ds);
    this.reset(true);
  }
  get index() {
    return this._index;
  }

  passDsToPages(ds) {
    this.tag('ProgramContainer').children[0].patch({
      datasource: ds,
    });
    this.tag('ProgramContainer').children[1].patch({
      datasource: ds,
    });
    this.tag('ProgramContainer').children[2].patch({
      datasource: ds,
    });
  }

  _active() {
    this.isActive = true;
    this.reset();
  }

  setTime(start, end) {
    this.currentStart = new Date(start);
    this.currentEnd = new Date(end);
    this.timeChanged = true;
    if (this.isActive) this.reset();
  }

  /**
   * @param {IFiltersInfo} filters
   */
  updateFilterHighlights(filters) {
    this.filterState = filters;
    this.tag('ProgramContainer').children.forEach(el => {
      el.updateFilterHighlights(filters);
    });
  }

  reset(forceReloadPages = false) {
    if (this.datasource) {
      this.tag('Contain').texture.src = this.datasource.getImage();
      this.tag('ChannelNumber').text.text = this.datasource.getChannelNumber();
      if (this.datasource.isFavorite()) {
        this.tag('FavoriteIcon').patch({ color: Theme.Colors.Primary });
      } else {
        this.tag('FavoriteIcon').patch({ color: Theme.Colors.White });
      }
      if (this.timeChanged || forceReloadPages) {
        this.reloadPages();
      }
    }
  }

  reloadPages() {
    this.timeChanged = false;
    this.tag('ProgramContainer').children[this.currentPageIndex].buildPage(this.currentStart, this.currentEnd);

    let copyStart = new Date(this.currentStart);
    let copyEnd = new Date(this.currentEnd);
    const prevStart = new Date(copyStart.setHours(copyStart.getHours() - 2));
    const prevEnd = new Date(copyEnd.setHours(copyEnd.getHours() - 2));
    this.tag('ProgramContainer').children[this.leftPageIndex].buildPage(prevStart, prevEnd);

    copyStart = new Date(this.currentStart);
    copyEnd = new Date(this.currentEnd);
    const nextStart = new Date(copyStart.setHours(copyStart.getHours() + 2));
    const nextEnd = new Date(copyEnd.setHours(copyEnd.getHours() + 2));
    this.tag('ProgramContainer').children[this.rightPageIndex].buildPage(nextStart, nextEnd);
  }

  _inactive() {
    this.isActive = false;
  }

  _handleRight() {
    if (this.allowMove) {
      this.allowMove = false;
      this.fireAncestors('$moveRight');
      return true;
    }
  }

  moveRight() {
    // update current time to 2 hours ahead
    this.currentStart.setHours(this.currentStart.getHours() + 2);
    this.currentEnd.setHours(this.currentEnd.getHours() + 2);

    // check if active
    if (this.isActive) {
      this.tag('ProgramContainer').children[this.currentPageIndex].setSmooth(
        'x',
        -_constants.channelProgramsWidth - CmsConstants.Card.borderSize,
        { duration: _constants.animationDurationSeconds }
      );
      this.tag('ProgramContainer').children[this.rightPageIndex].focusLeftRight = true;
      this.tag('ProgramContainer').children[this.rightPageIndex].setSmooth('x', 0, {
        duration: _constants.animationDurationSeconds,
      });

      const first = this.tag('ProgramContainer').children[this.leftPageIndex];
      first.patch({
        x: _constants.channelProgramsWidth,
      });
      const initalLeft = this.leftPageIndex;
      this.leftPageIndex = this.currentPageIndex;
      this.currentPageIndex = this.rightPageIndex;
      this.rightPageIndex = initalLeft;
      // this.tag('ProgramContainer').childList.remove(first);
      // this.tag('ProgramContainer').childList.add(first);

      // preload next page
      const copyStart = new Date(this.currentStart);
      const copyEnd = new Date(this.currentEnd);
      const nextStart = new Date(copyStart.setHours(copyStart.getHours() + 2));
      const nextEnd = new Date(copyEnd.setHours(copyEnd.getHours() + 2));
      Registry.setTimeout(() => {
        this.tag('ProgramContainer')
          .children[this.rightPageIndex].buildPage(nextStart, nextEnd)
          .then(() => {
            this.allowMove = true;
            this.tag('ProgramContainer').children[this.rightPageIndex].focusElement = 0;
          });
      }, _constants.animationDurationSeconds * 1000);
      // this._buildPage(first, nextStart, nextEnd);
    } else {
      this.timeChanged = true;
    }
  }

  _handleLeft() {
    // const now = Date.now();
    // if (now - this.prevLeftRightTime < this.leftRightTimeout) return;
    // this.prevLeftRightTime = now;
    if (this.allowMove) {
      this.allowMove = false;
      this.fireAncestors('$moveLeft');
    }
  }

  moveLeft() {
    // update current time to 2 hours back
    this.currentStart.setHours(this.currentStart.getHours() - 2);
    this.currentEnd.setHours(this.currentEnd.getHours() - 2);

    // check if active
    if (this.isActive) {
      this.tag('ProgramContainer').children[this.currentPageIndex].setSmooth('x', _constants.channelProgramsWidth, {
        duration: _constants.animationDurationSeconds,
      });
      this.tag('ProgramContainer').children[this.leftPageIndex].focusLeftRight = false;

      this.tag('ProgramContainer').children[this.leftPageIndex].setSmooth('x', 0, {
        duration: _constants.animationDurationSeconds,
      });

      const last = this.tag('ProgramContainer').children[this.rightPageIndex];
      last.patch({
        x: -_constants.channelProgramsWidth - CmsConstants.Card.borderSize,
      });
      const initalRight = this.rightPageIndex;
      this.rightPageIndex = this.currentPageIndex;
      this.currentPageIndex = this.leftPageIndex;
      this.leftPageIndex = initalRight;
      // this.tag('ProgramContainer').childList.remove(last);
      // this.tag('ProgramContainer').childList.addAt(last, 0);

      // preload next page
      const copyStart = new Date(this.currentStart);
      const copyEnd = new Date(this.currentEnd);
      const prevStart = new Date(copyStart.setHours(copyStart.getHours() - 2));
      const prevEnd = new Date(copyEnd.setHours(copyEnd.getHours() - 2));
      // this.allowMove = false;
      Registry.setTimeout(() => {
        this.tag('ProgramContainer')
          .children[this.leftPageIndex].buildPage(prevStart, prevEnd)
          .then(() => {
            this.allowMove = true;
          });
      }, _constants.animationDurationSeconds * 1000);
      // this._buildPage(last, prevStart, prevEnd);
    } else {
      this.timeChanged = true;
    }
  }

  getCurrentPosition() {
    const focussedEl = this._getFocused()._getFocused();
    // to ways of up/down behavior, take x val or center of program
    let xPos = 0;
    if (focussedEl) {
      // xPos = focussedEl.finalX + focussedEl.finalW / 2;
      xPos = focussedEl.finalX;
    }
    return xPos;
  }

  setPreferedFocus(xPos) {
    const currentPagePrograms = this._getFocused()._getFocusable();
    let newFocus = 0;
    for (let i = 0; i < currentPagePrograms.length; i++) {
      if (currentPagePrograms[i].finalX <= xPos) {
        newFocus = i;
      }
    }
    this._getFocused().focusElement = newFocus;
  }
}
